import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { Industry } from '../../models/common/industry.model';
import { Resource } from '../../models/resources/resource.model';
import { PrimaryIndustryService } from '../../services/primary-industry.service';
import { ResourcesService } from '../../services/resources.service';
import { ToastsService } from '../../services/toasts.service';
import { Base } from '../base/base';
import { User } from '../../models/user/user.model';
import { Title } from '@angular/platform-browser';
import { EventTrackingService } from 'src/app/services/event-tracking.service';
import { EventName } from '../../../environments/environment';

@Component({
  selector: 'safetydirector-memic-minutes',
  templateUrl: './memic-minutes.component.html',
  styleUrls: ['./memic-minutes.component.css'],
  providers: [ResourcesService]
})
export class MemicMinutesComponent extends Base implements OnInit, OnDestroy {
  private BusyA;
  private BusyB;
  private BusyC;

  public sortKey = 'modified';
  public sortTitle = 'Publish Date';

  public selectedIndustry: string;
  public primaryIndustries: Industry[];

  public resourcesCopy: Resource[] | any;
  public resources: Resource[] | any;
  public baseUrl: string;
  public searchString: string | null = null;

  public documentTypes: any;
  public documentTypesCheckArray: Array<string> = [];
  public featuredTopics: any;
  public featuredTopicsCheckArray: Array<string> = [];
  public secondaryFeaturedTopics: any;
  public secondaryFeaturedTopicsCheckArray: Array<string> = [];

  public pageName = "MEMIC Minutes";

  public tagsLength = 4;

  constructor(
    private resourcesService: ResourcesService,
    private primaryIndustryService: PrimaryIndustryService,
    private toastsService: ToastsService,
    private router: ActivatedRoute,
    private titleService: Title,
    private eventTrackingService:EventTrackingService) {
    super();
    this.titleService.setTitle(this.basePageTitle + this.pageName);
  }

  ngOnInit(): void {
    const industry = this.getIndustry();
    this.selectedIndustry = industry;
    let searchStringNav = this.router.snapshot.queryParamMap.get('searchString');

    if (searchStringNav) {
      this.searchString = searchStringNav;
    }

    this.initializeResources();
  }

  public initializeResources() {
    this.resourcesCopy = null;
    this.resources = null;

    this.documentTypesCheckArray = [];
    this.featuredTopicsCheckArray = [];
    this.secondaryFeaturedTopicsCheckArray = [];

    this.BusyA = this
      .resourcesService
      .getAllMemicMinutesResources(this.selectedIndustry)
      .subscribe(result => {
        this.resourcesCopy = result;
        this.resources = result;

        if (this.searchString) {
          this.filterResources();
        } else {
          this.initializeRefiners();
        }
      });

    this.BusyB = this
      .primaryIndustryService
      .getIndustries()
      .subscribe(result => {
        this.primaryIndustries = result;
      });
  }

  public filterResources(clearSearch = false) {
    this.resources = this.resourcesCopy;

    if (clearSearch) {
      this.searchString = null;
    }

    // search string
    if (this.searchString) {
      let ss = this.searchString.toLowerCase();
      this.resources = _.filter(this.resources, function (r) {
        return (r.title && r.title.toLowerCase().includes(ss)) ||
          (r.resourceDescription && r.resourceDescription.toLowerCase().includes(ss)) ||
          (r.documentType && r.documentType.toLowerCase().includes(ss)) ||
          (r.primaryFeatureTopic && r.primaryFeatureTopic.toLowerCase().includes(ss)) ||
          (r.secondaryFeaturedTopic && r.secondaryFeaturedTopic.join('|#|~~|#|').toLowerCase().includes(ss));
      });
    }
 
    // filter document types
    if (this.documentTypesCheckArray && this.documentTypesCheckArray.length > 0) {
      let dtcArray = this.documentTypesCheckArray;

      this.resources = _.filter(this.resources, function (r) {
        return _.find(dtcArray, dtc => dtc == r.documentType) && true;
      });
      
    }
    // filter featured topics
    if (this.featuredTopicsCheckArray && this.featuredTopicsCheckArray.length > 0) {
      let ftcArray = this.featuredTopicsCheckArray;
      this.resources = _.filter(this.resources, function (r) {
        return _.find(ftcArray, ftc => ftc == r.primaryFeatureTopic) && true;
      });      
    }
    // filter secondary featured topics
    if (this.secondaryFeaturedTopicsCheckArray && this.secondaryFeaturedTopicsCheckArray.length > 0) {
      let stcArray = this.secondaryFeaturedTopicsCheckArray;
      this.resources = _.filter(this.resources, function (r) {
        return _.find(stcArray, stc => r.secondaryFeaturedTopic.join('|#|~~|#|').includes(stc)) && true;
      });      
    }

    this.updateSortBy(this.sortKey, this.sortTitle, this.sortKey === 'title' ? 'asc' : 'desc');
    this.initializeRefiners();   
  }

  public initializeRefiners() {
    //Document Type
    this.documentTypes = _.filter(_.sortBy(_.uniq(_.map(this.resources, 'documentType'))), function (d) { return d });

    // Featured Topics
    this.featuredTopics = _.filter(_.sortBy(_.uniq(_.map(this.resources, 'primaryFeatureTopic'))), function (f) { return f });

    // Secondary Featured Topics
    this.secondaryFeaturedTopics = _.filter(_.sortBy(_.uniq(_.flatten(_.map(this.resources, 'secondaryFeaturedTopic')))), function (s) { return s });
  }

  public onCheckboxChange(e, filter) {
    var checkboxFilter = '';
    if (e.target.value && e.target.checked) {
      if (filter == 'documentType') {
        checkboxFilter =filter;
        if (this.documentTypesCheckArray && !_.find(this.documentTypesCheckArray, d => d == e.target.value)) {
          this.documentTypesCheckArray.push(e.target.value);
        }
      } else if (filter == 'featuredTopic') {
        checkboxFilter = filter;
        if (this.featuredTopicsCheckArray && !_.find(this.featuredTopicsCheckArray, f => f == e.target.value)) {
          this.featuredTopicsCheckArray.push(e.target.value);
        }
      } else if (filter == 'secondaryFeaturedTopic') {
        checkboxFilter = filter;
        if (this.secondaryFeaturedTopicsCheckArray && !_.find(this.secondaryFeaturedTopicsCheckArray, s => s == e.target.value)) {
          this.secondaryFeaturedTopicsCheckArray.push(e.target.value);
        }
      }

      e.target.checked = false;
    }

    this.filterResources();
    
    if (filter == 'featuredTopic') {
      // track OnCheckbox change event for featuredTopic.
      this.eventTrackingService.trackEvent('TrackEvent', {
        'Event': EventName.memicMinutesFeaturedTopicFilter
        , 'FilterValue': e.target.value
      });
    }
    else if (filter == 'secondaryFeaturedTopic') {
      // track OnCheckbox change event for secondary featured topic.
      this.eventTrackingService.trackEvent('TrackEvent', {
        'Event': EventName.memicMinutesSecondaryFeaturedTopicFilter
        , 'FilterValue': e.target.value
      });
    }
  }

  public onClearRefiner(r, filter) {
    if (r) {
      if (filter == 'documentType') {
        if (this.documentTypesCheckArray && _.find(this.documentTypesCheckArray, d => d == r)) {
          _.remove(this.documentTypesCheckArray, d => d == r)
        }
      } else if (filter == 'featuredTopic') {
        if (this.featuredTopicsCheckArray && _.find(this.featuredTopicsCheckArray, d => d == r)) {
          _.remove(this.featuredTopicsCheckArray, f => f == r)
        }
      } else if (filter == 'secondaryFeaturedTopic') {
        if (this.secondaryFeaturedTopicsCheckArray && _.find(this.secondaryFeaturedTopicsCheckArray, d => d == r)) {
          _.remove(this.secondaryFeaturedTopicsCheckArray, s => s == r)
        }
      }
    }

    this.filterResources();

    // track onClearRefiner event
    this.eventTrackingService.trackEvent('TrackEvent', {
      'Event': EventName.memicMinutesOnClearRefiner
      , 'ClearFilter': filter
    });
  }

  public onResetRefiner(filter) {
    if (filter == 'documentType') {
      this.documentTypesCheckArray = [];
    } else if (filter == 'featuredTopic') {
      this.featuredTopicsCheckArray = [];
    } else if (filter == 'secondaryFeaturedTopic') {
      this.secondaryFeaturedTopicsCheckArray = [];
    }

    this.filterResources();
  }

  public downloadFile(file, fileIcon) {
    let fileName = file.blobName;
    let user: User = this.getUserDetailsFromLocalStorage();
    // Replace the file icon with a spinner, save the original icon to replace when download is complete
    let originalFileIconSrc = fileIcon.src;
    fileIcon.src = "../../assets/images/spinner.gif"

    this.BusyC = this
      .resourcesService
      .downloadFile(file, this.getIndustry(), user.policyNumber, user.emailAddress)
      .subscribe(result => {
        const a = document.createElement('a')
        const objectUrl = URL.createObjectURL(result)
        a.href = objectUrl
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(objectUrl);
        // Put back the original icon
        fileIcon.src = originalFileIconSrc;
        this.toastsService.showSuccess(`Successfully downloaded '${fileName}'`);
      });
    // track download file event
    this.eventTrackingService.trackEvent('TrackEvent', {
        'Event': EventName.memicMinutesDownloadFile
      , 'FileName': fileName
    });
  }

  public updateIndustry(industry: string): void {
    this.selectedIndustry = industry;
    this.searchString = null;    
    this.initializeResources();

    // Reset SortBy
    this.sortTitle = "Publish Date"

    // track update event
    this.eventTrackingService.trackEvent('TrackEvent', {
      'Event': EventName.memicMinutesUpdateIndustry,
      'Industry': industry
    });
  }

  public updateSortBy(key: string, title: string, order: _.Many<boolean | 'asc' | 'desc'>): void {
    this.sortKey = key;
    this.sortTitle = title;

    this.resources = _.orderBy(this.resources, this.sortKey, order);
  }

  private getKeyWordsHtmlHelper(keyword: string): string {
    return keyword ? `<section class="memic-tag m-r-1 m-t-1" > <i class="fa fa-tag p-l-1 m-r-1" aria-hidden="true" > </i><span class="p-r-1">${keyword}</span > </section>` : '';
  }

  public getKeyWordsHtml(resource: Resource, firstFew: boolean = true): string {
    let keyWordsHtml = '';
    let start, end = 0;

    let keywords = this.getKeyWords(resource);

    if (firstFew) {
      start = 0;
      end = this.tagsLength;
    } else {
      start = this.tagsLength;
      end = keywords?.length;
    }

    _.each(_.slice(keywords, start, end), k => keyWordsHtml += this.getKeyWordsHtmlHelper(k));

    return keyWordsHtml;
  }

  public getKeyWords(resource: Resource): string[] {
    let keyWords: string[] = [];

    // Add Document Types
    if (resource.documentType) {
      keyWords.push(resource.documentType);
    }

    // Add Featured Topic
    if (resource.primaryFeatureTopic) {
      keyWords.push(resource.primaryFeatureTopic);
    }

    //Add Secondary Featured Topics
    if (resource.secondaryFeaturedTopic && resource.secondaryFeaturedTopic.length > 0) {
      for (let i = 0; i < resource.secondaryFeaturedTopic.length; i++) {
        keyWords.push(resource.secondaryFeaturedTopic[i]);
      }
    }

    return keyWords;
  }

  public toggleTags(resource: Resource) {
    if (resource.more) {
      resource.more = false
    } else {
      resource.more = true;
    }
  }

  ngOnDestroy(): void {
    if (this.BusyA) {
      this.BusyA.unsubscribe();
    }

    if (this.BusyB) {
      this.BusyB.unsubscribe();
    }

    if (this.BusyC) {
      this.BusyC.unsubscribe();
    }
  }
}
